import {Pipe, PipeTransform} from '@angular/core';
import {LoggerService} from '../../hbs-services';

@Pipe({
    name: 'qLabel'
})
export class QuestionLabelPipe implements PipeTransform {

    constructor(private logger: LoggerService) {
    }

    /**
     *
     * @param value - is a question
     * @param args
     * @returns {any}
     */
    transform(value: any, args: any[]): any {
        let label = '';
        if (value) {
            let questLabel: string;
            if (value.questLabel === undefined) {
                questLabel = 'default';
            } else {
                questLabel = String(value.questLabel);
            }
            if (questLabel !== '' && questLabel !== 'none') {
                if (questLabel === 'default') {
                    questLabel = 'Question #:';
                }
                const qNum = value.questNum;
                label = questLabel.replace('\#', qNum);
            }
        }
        // this.logger.log('QuestionLabelPipe:', 'value:', value, 'label:', label);
        return label;
    }
}
